<script lang="ts">
  import { defineComponent } from "vue";
  import FicheVirementEtablissement from '@/generated/fiches/FicheVirementEtablissement.vue';
  export default defineComponent({
    extends: FicheVirementEtablissement,
    components: {}
})
</script>
